import {Modal} from "antd";
import {IoMdCheckmarkCircle} from "react-icons/io";

const Success = ({visible, onClose}) => {
    return (
        <Modal open={visible}
               onCancel={onClose}
               footer={null}
               className={"!w-fit"}>
            <div className={"text-center p-4"}>
                <IoMdCheckmarkCircle className={"w-32 h-32 justify-center mx-auto text-green-400"}/>
                <h2 className={"text-2xl font-semibold text-gray-700 text-center mb-2"}>Bạn đã ứng tuyển thành
                    công!</h2>
            </div>
        </Modal>
    )
}

export default Success;